import SearchIcon from "components/icons/SearchIcon";
import React, {useEffect, useMemo, useState} from "react";
import {
    MdChevronLeft,
    MdChevronRight,
    MdDeleteForever,
    MdDeleteOutline,
    MdEdit,
    MdOutlineCancel,
    MdOutlineSave
} from "react-icons/md";
import {useGlobalFilter, usePagination, useSortBy, useTable,} from "react-table";
import {DiAndroid, DiApple} from "react-icons/di";
import {utils, writeFile} from "xlsx";
import axios from "axios";
import {AES, enc} from "crypto-js";
import {useUserAuth} from "../../../../../context/UserAuthContext";
import {useNavigate, useParams} from "react-router-dom";
import DataPointsCardView from "./DataPointsCardView";

function DataPointsTable(props) {
    const {columnsData, tableData} = props;
    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";
    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();
    const params = useParams();

    let [newRange, setNewRange] = useState([])
    let [newPitch, setNewPitch] = useState([])
    let [newUnit, setNewUnit] = useState([])


    const columns = useMemo(() => columnsData, [columnsData]);
    const data = useMemo(() => tableData, [tableData]);


    const tableInstance = useTable(
        {
            columns,
            data,
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,

        prepareRow,
        nextPage,
        previousPage,
        setPageSize,

        setGlobalFilter,
        state,
    } = tableInstance;

    const {pageSize} = state;
    const currentPage = state.pageIndex; // Page index starts from 0
    const totalPages = Math.ceil(data.length / pageSize);
    let [changedDps, setChangedDps] = useState([])
    let [changedDeleteDps, setChangedDeleteDps] = useState([])
    let [changedUpdateDps, setChangedUpdateDps] = useState([])
    let [dps, setDps] = useState([])
    let [allDps, setAllDps] = useState([])
    let [isLoading, setIsLoading] = useState(false)
    let [dpEditable, setDpEditable] = useState(false);
    let [contentChanged, setContentChanged] = useState(false)
    let [newDpProperties, setNewDpProperties] = useState("")
    let [dpNames, setDpNames] = useState("")

    function convertGMTtoIST(gmtDateTime) {
        // Create a new Date object with the GMT date and time
        const gmtDate = new Date(gmtDateTime);

        // Get the time zone offset for IST
        const istOffset = gmtDate.getTimezoneOffset() + 330; // IST is UTC+5:30

        // Create a new Date object with the IST date and time
        const istDate = new Date(gmtDate.getTime() + istOffset);

        // Return the IST date and time in DD/MM/YYYY HH:MM format
        return istDate.toLocaleString('en-IN', {timeZone: 'Asia/Kolkata'});
    }

    function getCurrentDate() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Jan is 0!
        const year = today.getFullYear();

        return `${day}-${month}-${year}`
    }

    function exportUserData() {
        let filteredData

        filteredData = data.map((item) => ({
            DpId: item.dpid,
            Name: item.dpName,
            Type: item.dpType,
            Properties: item.dpProperties
        }));

        let wb = utils.book_new(),
            ws = utils.json_to_sheet(filteredData);
        utils.book_append_sheet(wb, ws, "crompton_dpid_details")
        writeFile(wb, "crompton_dpid_details_" + getCurrentDate() + ".xlsx")
    }

    function modifyUserAccessLevelApi(emailPhone, acl) {
        var bodyFormData;
        let index = emailPhone.indexOf("@");

        if (index === -1) {
            bodyFormData = {
                mobile: emailPhone,
                acl: acl
            }
        } else {
            bodyFormData = {
                email: emailPhone,
                acl: acl
            }
        }
        //console.log(bodyFormData)
        return axios({
            method: 'put',
            url: CROMPTON_URL + 'user/updateAcl',
            data: bodyFormData,
            headers: {
                Authorization: decryptedValue,
            }
        }).then(response => {
            // console.log(response)
            window.location.reload()

        })
            .catch(
                error => {
                    // console.log(error)
                }
            )
    }

    function formatData(dataString) {
        // Split the data string at each colon and trim leading/trailing spaces
        const dataLines = dataString.split(':').map(line => line.trim());
        // Join with line breaks
        return dataLines.join('\n');
    }

    function splitDpPropertiesString(data) {
        const indexOfPitch = data.indexOf("Value:");
        const valueString = data.substring(0, indexOfPitch);
        const pitchString = data.substring(indexOfPitch);
        const unitString = pitchString.indexOf("Pitch:")
        const finalUnitString = pitchString.substring(0, unitString);
        //console.log(pitchString, finalUnitString, unitString)
        return [valueString, pitchString, finalUnitString];
    }

    function changePitch(event, index) {
        const newArray = [...newPitch]; // Create a copy of the array
        newArray[index] = event.target.textContent; // Update the value at the desired index
        setNewPitch(newArray); // Update the state with the modified array
    }

    function changeUnit(event, index) {
        const newArray = [...newUnit]; // Create a copy of the array
        newArray[index] = event.target.textContent; // Update the value at the desired index
        setNewUnit(newArray); // Update the state with the modified array
    }

    function changeRange(event, index) {
        //console.log(index)

        const newArray = [...newRange]; // Create a copy of the array
        newArray[index] = event.target.textContent; // Update the value at the desired index
        setNewRange(newArray); // Update the state with the modified array

        //setNewRange(event.target.textContent)

    }

    function saveDpIdProperties(rowData, index) {
        //console.log(rowData)
        const {dpName, dpProperties, dpid, dpType, dpRange, pitch, unit, ...otherData} = rowData;
        setGlobalFilter("")


        setDpEditable(false)

        let updatedDataPoint = {
            productId: params.id,
            dpid: dpid,
            dpType: dpType,
            dpRange: newRange[index] !== "" ? newRange[index] : dpRange,
            pitch: pitch,
            unit: unit,
            direction: 1
        }

        //console.log(updatedDataPoint)
        changedUpdateDps.push(updatedDataPoint)
        sessionStorage.setItem("changedDps", JSON.stringify(changedUpdateDps))
        setContentChanged(true)

        setGlobalFilter("")
        /* if (rowData.email !== null) {
             //console.log(rowData.email)
             modifyUserAccessLevelApi(rowData.email, acl)
         } else {
             //console.log(rowData.mobileNumber)
             modifyUserAccessLevelApi(rowData.mobileNumber, acl)
         }*/

    }

    function editingCancel() {
        //console.log(rowData)
        setGlobalFilter("")
        setChangedDps([])
        setDpEditable(false)
    }

    function deleteDpId(rowData) {
        //console.log(rowData)
        const {dpName, dpProperties, dpid, ...otherData} = rowData;
        //setGlobalFilter("")
        setDpEditable(false)

        let deletedDataPoint = {
            productId: params.id,
            dpid: dpid,
            dpType: "Boolean",
            dpRange: "",
            pitch: "",
            unit: "",
            direction: 1
        }
        changedDeleteDps.push(deletedDataPoint)
        sessionStorage.setItem("deletedDps", JSON.stringify(changedDeleteDps))
        setGlobalFilter("")
        setContentChanged(true)
    }

    function editDpAccess(rowData) {
        const {dpName, type, dpid, ...otherData} = rowData;
        //console.log(getDpFromDpid(rowData.dpid))
        //console.log(rowData)
        setGlobalFilter(rowData.dpName && rowData.dpid)

        setDpEditable(true)
    }

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    async function getAllDps() {
        var url = CROMPTON_ANALYTICS_URL + "v1/device/dpIds"

        //console.log("URL: ", url)
        await axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }

        }).then((res) => {
            //console.log(res.data)
            // Function to determine if a DP exists in data
            dps = res.data
            setAllDps(res.data)
            allDps = res.data
            //console.log(data)
            const isInData = (dp) => data.some((item) => item.dpid === dp.dpid);

// Filter dps to remove those present in data
            const filteredDps = dps.filter((dp) => !isInData(dp));

// Update your dps state with the filtered array
            setDps(filteredDps); // Assuming you use a state variable for dps
            dps = filteredDps
            //setDps(res.data)

            setIsLoading(false)

        }).catch((error) => {
            setIsLoading(false)
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })
    }

    const handleSelect = (selectedIds) => {
        //console.log('Selected items:', selectedIds.join(","));
        //console.log(selectedIds.length);
        if (selectedIds.length === 0) {
            setContentChanged(false)
        } else {
            setContentChanged(true)
            sessionStorage.setItem("addedDps", selectedIds.join(","))
        }
    };

    useEffect(() => {
        setIsLoading(true)
        //console.log(data)
        getAllDps()
    }, []);

    const editDpProperties = (event) => {
        //console.log(event)
        setNewDpProperties(event.target.textContent);
        newDpProperties = event.target.textContent
    };


    return (
        !isLoading &&
        <div className="h-full w-full">
            {/* Search */}
            <h2 className="text-lg font-bold text-navy-700 dark:text-white">
                Data Points: Function Definition
            </h2>
            <div className="relative flex items-center justify-between">
                <div
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    className="flex w-full max-w-[400px] items-center rounded-xl p-[8px] pt-[20px] xl:ml-3"
                >
                    <div
                        className="flex h-[38px] w-full flex-grow items-center rounded-xl bg-lightPrimary text-sm text-gray-600 dark:!bg-navy-900 dark:text-white">
                        <SearchIcon/>
                        <input
                            type="text"
                            placeholder="Search...."
                            className="block w-full rounded-full bg-lightPrimary text-base text-navy-700 outline-none dark:!bg-navy-900 dark:text-white"
                        />
                    </div>
                </div>
                <DataPointsCardView data={dps} onSelect={handleSelect}/>
                <button
                    className=" mb-3 flex items-center justify-center text-sm font-bold text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white"
                    onClick={exportUserData}
                >
                    Export Data
                </button>
            </div>

            {/* table */}
            <div className="mt-[25px] overflow-x-scroll 2xl:overflow-x-hidden">
                <table {...getTableProps()} className="mt-8 h-max w-full" variant="simple" color="gray-500"
                       mb="24px">
                    <thead className="w-full">
                    {headerGroups.map((headerGroup, index) => (
                        <tr
                            className="items-center border-b border-gray-200 text-base dark:border-white/10"
                            {...headerGroup.getHeaderGroupProps()}
                            key={index}
                        >
                            {headerGroup.headers.map((column, index) => (
                                <th
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    className="border-b border-gray-200 pr-32 pb-[10px] text-start dark:!border-navy-700"
                                    key={index}
                                >
                                    <div className="text-xs font-bold tracking-wide text-gray-600">
                                        {column.render("Header")}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                    {page.map((row, indexPage) => {
                        prepareRow(row);
                        return (
                            <tr
                                className="border-b border-gray-200 dark:!border-white/10"
                                {...row.getRowProps()}
                                key={indexPage}
                            >
                                {row.cells.map((cell, index) => {
                                    let data = "";
                                    switch (cell.column.Header) {
                                        case "ID":
                                            data = (
                                                <div className="flex items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value}
                                                    </p>
                                                </div>
                                            );
                                            break
                                        case "NAME":
                                            data = (
                                                <div className="flex items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value}
                                                    </p>
                                                </div>
                                            );
                                            break
                                        case "TYPE":
                                            data = (
                                                <div className="flex items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value}
                                                    </p>
                                                </div>
                                            );
                                            break
                                        case "RANGE": {
                                            !dpEditable ?
                                                cell.value !== null ?
                                                    data = (
                                                        <div className="flex items-center gap-2">
                                                            <p className="text-sm font-bold text-navy-700 dark:text-white"
                                                               contentEditable={false}>
                                                                {newRange[cell.row.index] !== "" ? cell.value : newRange[cell.row.index]}
                                                            </p>
                                                        </div>
                                                    )
                                                    :
                                                    data = (
                                                        <div className="flex items-center gap-2">
                                                            <p className="text-sm font-bold text-navy-700 dark:text-white"
                                                               contentEditable={false}>
                                                                {newRange[cell.row.index] === "" ? " " : newRange[cell.row.index]}
                                                            </p>
                                                        </div>
                                                    )
                                                :
                                                cell.value !== null ?
                                                    data = (
                                                        <div className="flex items-center gap-2">
                                                            <p className="text-sm font-bold text-navy-700 dark:text-white"
                                                               contentEditable={true}
                                                               onInputCapture={(event) => changeRange(event, cell.row.index)}>
                                                                {cell.value}
                                                            </p>
                                                        </div>
                                                    )
                                                    :
                                                    data = (
                                                        <div className="flex items-center gap-2">
                                                            <p className="text-sm font-bold text-navy-700 dark:text-white"
                                                               contentEditable={true}
                                                               onInputCapture={((event) => changeRange(event, cell.row.index))}>
                                                                &nbsp;
                                                            </p>
                                                        </div>
                                                    );
                                        }

                                            break
                                        case "UNIT": {
                                            !dpEditable ?
                                                cell.value !== null ?
                                                    data = (
                                                        <div className="flex items-center gap-2">
                                                            <p className="text-sm font-bold text-navy-700 dark:text-white"
                                                               contentEditable={false}>
                                                                {newUnit[cell.row.index] !== "" ? cell.value : newUnit[cell.row.index]}
                                                            </p>
                                                        </div>
                                                    )
                                                    :
                                                    data = (
                                                        <div className="flex items-center gap-2">
                                                            <p className="text-sm font-bold text-navy-700 dark:text-white"
                                                               contentEditable={false}>
                                                                {newUnit[cell.row.index] === "" ? " " : newUnit[cell.row.index]}
                                                            </p>
                                                        </div>
                                                    )
                                                :
                                                cell.value !== null ?
                                                    data = (
                                                        <div className="flex items-center gap-2">
                                                            <p className="text-sm font-bold text-navy-700 dark:text-white"
                                                               contentEditable={true}
                                                               onInputCapture={(event) => changeUnit(event, cell.row.index)}>
                                                                {cell.value}
                                                            </p>
                                                        </div>
                                                    )
                                                    :
                                                    data = (
                                                        <div className="flex items-center gap-2">
                                                            <p className="text-sm font-bold text-navy-700 dark:text-white"
                                                               contentEditable={true}
                                                               onInputCapture={((event) => changeUnit(event, cell.row.index))}>
                                                                &nbsp;
                                                            </p>
                                                        </div>
                                                    );
                                        }
                                            break
                                        case "PITCH": {
                                            !dpEditable ?
                                                cell.value !== null ?
                                                    data = (
                                                        <div className="flex items-center gap-2">
                                                            <p className="text-sm font-bold text-navy-700 dark:text-white"
                                                               contentEditable={false}>
                                                                {newPitch[cell.row.index] !== "" ? cell.value : newPitch[cell.row.index]}
                                                            </p>
                                                        </div>
                                                    )
                                                    :
                                                    data = (
                                                        <div className="flex items-center gap-2">
                                                            <p className="text-sm font-bold text-navy-700 dark:text-white"
                                                               contentEditable={false}>
                                                                {newPitch[cell.row.index] === "" ? " " : newPitch[cell.row.index]}
                                                            </p>
                                                        </div>
                                                    )
                                                :
                                                cell.value !== null ?
                                                    data = (
                                                        <div className="flex items-center gap-2">
                                                            <p className="text-sm font-bold text-navy-700 dark:text-white"
                                                               contentEditable={true}
                                                               onInputCapture={(event) => changePitch(event, cell.row.index)}>
                                                                {cell.value}
                                                            </p>
                                                        </div>
                                                    )
                                                    :
                                                    data = (
                                                        <div className="flex items-center gap-2">
                                                            <p className="text-sm font-bold text-navy-700 dark:text-white"
                                                               contentEditable={true}
                                                               onInputCapture={((event) => changePitch(event, cell.row.index))}>
                                                                &nbsp;
                                                            </p>
                                                        </div>
                                                    );
                                        }
                                            break
                                        /*case "PROPERTIES" :
                                            data = (
                                                !dpEditable ?
                                                    <div className="items-center gap-2">
                                                        <p className="text-sm font-bold text-navy-700 dark:text-white"
                                                           contentEditable={false}>
                                                            {splitDpPropertiesString(cell.value)[0]}
                                                        </p>
                                                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                            {splitDpPropertiesString(cell.value)[1]}
                                                        </p>
                                                        {/!*<p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {splitDpPropertiesString(cell.value)[2]}
                                                    </p>*!/}
                                                    </div> :

                                                    <div className="items-center gap-2" contentEditable={true}>
                                                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                            {splitDpPropertiesString(cell.value)[0]}
                                                        </p>
                                                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                            {splitDpPropertiesString(cell.value)[1]}
                                                        </p>
                                                        {/!*<p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {splitDpPropertiesString(cell.value)[2]}
                                                    </p>*!/}
                                                    </div>
                                            );
                                            break*/

                                        case "ACTIONS": {
                                            !dpEditable ?
                                                data = (
                                                    <button
                                                        className="max-h-fit w-full max-w-max cursor-pointer ml-5 text-xl text-gray-600"
                                                        onClick={() => editDpAccess(cell.row.original)}
                                                        id="editButton">
                                                        <MdEdit onClick={() => editDpAccess(cell.row.original)}/>
                                                    </button>
                                                ) :
                                                data = (
                                                    cell.row.original.dpType.toLowerCase() !== "boolean" ?
                                                        <div
                                                            className="flex items-center"> {/* Use flexbox for one line */}
                                                            <button
                                                                className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600 mr-2"
                                                                id="editButton">
                                                                <MdOutlineSave className="text-green-800 "
                                                                               onClick={() => saveDpIdProperties(cell.row.original, cell.row.index)}/>
                                                            </button>
                                                            <button
                                                                className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600 mr-2"
                                                                id="editButton">
                                                                <MdOutlineCancel className="text-gray-700"
                                                                                 onClick={editingCancel}/>
                                                            </button>
                                                            <button
                                                                className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600"
                                                                id="editButton">
                                                                <MdDeleteOutline className="text-red-800"
                                                                                 onClick={() => deleteDpId(cell.row.original)}/>
                                                            </button>
                                                        </div> :
                                                        <div
                                                            className="flex items-center"> {/* Use flexbox for one line */}
                                                            <button
                                                                className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600 mr-2 invisible"
                                                                id="editButton">
                                                                <MdOutlineSave className="text-gray-800"/>
                                                            </button>
                                                            <button
                                                                className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600 mr-2"
                                                                id="editButton">
                                                                <MdOutlineCancel className="text-gray-700"
                                                                                 onClick={editingCancel}/>
                                                            </button>
                                                            <button
                                                                className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600"
                                                                id="editButton">
                                                                <MdDeleteOutline className="text-red-800"
                                                                                 onClick={() => deleteDpId(cell.row.original)}/>
                                                            </button>
                                                        </div>

                                                )
                                        }
                                    }
                                    return (
                                        <td
                                            {...cell.getCellProps()}
                                            key={index}
                                            className="pt-[14px] pb-[16px] sm:text-[14px]"
                                        >
                                            {data}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>

            {/* pagination */}
            {!setDpEditable &&
                <div className=" mt-2 flex h-20 w-full items-center justify-between px-6">
                    {/* left side */}
                    <div className=" flex items-center gap-3">
                        <p className="> Show rows per page text-sm text-gray-700 font-bold dark:text-white">
                            Show rows per page{" "}
                        </p>
                        <select
                            value={pageSize}
                            onChange={(e) => setPageSize(Number(e.target.value))}
                            className="h-[32px] w-[75px] rounded-[20px] border border-gray-700 px-2 text-gray-700 font-bold dark:!border-white/10 dark:bg-navy-800 dark:text-white"
                            name=""
                            id=""
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                        </select>
                    </div>
                    <div className="flex items-center gap-4">
                        <p className="text-sm font-bold text-gray-700 dark:text-white">
                            Page {currentPage + 1} of {totalPages}
                        </p>
                    </div>
                    {/* right side */}
                    <div className="flex items-center gap-3">
                        {state.pageIndex !== 0 && (
                            <button
                                onClick={previousPage}
                                disabled={state.pageIndex === 0}
                                className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                            >
                                <MdChevronLeft/>
                            </button>
                        )}
                        <p className="text-sm text-gray-700 font-bold dark:text-white ">
                            {currentPage + 1}
                        </p>
                        {state.pageIndex !== totalPages - 1 && (
                            <button
                                onClick={nextPage}
                                disabled={state.pageIndex === totalPages}
                                className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                            >
                                <MdChevronRight/>
                            </button>
                        )}
                    </div>
                </div>
            }
            {
                contentChanged &&
                <p className="mt-3 text-center text-sm font-normal text-green-800 dark:text-green-800">
                    {"**Data Points are modified and need to be saved before they can take effect."}
                </p>
            }

            {
                !contentChanged &&
                <p className="mt-3 text-center text-sm font-normal text-green-800 dark:text-green-800">
                    &nbsp;
                </p>
            }


        </div>
    )
        ;
}

export default DataPointsTable;

